
  var _cookieDomain = "seoulmills.com";

  document.domain = _cookieDomain;

  function setCookie(cName, cValue, cDay)
  {
    var cookies = cName + '=' + escape(cValue);

    if(typeof cDay != 'undefined')
    {
      var expire = new Date();
      expire.setDate(expire.getDate() + cDay);
  //expire.setMinutes(expire.getMinutes() + cDay);
      cookies += ';expires=' + expire.toUTCString();
    }

    if(typeof _cookieDomain != 'undefined')
    {
      cookies += ';domain=' + _cookieDomain;
    }

    cookies += ';path=/';

    document.cookie = cookies;
  //console.log("cookies:|" + cookies + "|");
  }

  function getCookie(cName)
  {
    var cookieData = document.cookie;

    var cNameEq = cName + '=';
    var cValue = '';
    var sidx = cookieData.indexOf(cNameEq);
    if(sidx != -1)
    {
      sidx += cNameEq.length;
      var eidx = cookieData.indexOf(';', sidx);
      if(eidx == -1)
      {
        eidx = cookieData.length;
      }
      cValue = cookieData.substring(sidx, eidx);
      cValue = unescape(cValue);
    }

//console.log("cValue:|" + cValue + "|");
    return cValue;
  }

  function getSimpleFormattedUtcDate(date)
  {
    var formatted = "";
    formatted = date.getUTCFullYear();
    formatted += get2DigitByFirstZeroPadding(date.getUTCMonth() + 1);
    formatted += get2DigitByFirstZeroPadding(date.getUTCDate());
    formatted += "_";
    formatted += get2DigitByFirstZeroPadding(date.getUTCHours());
    formatted += get2DigitByFirstZeroPadding(date.getUTCMinutes());
    formatted += get2DigitByFirstZeroPadding(date.getUTCSeconds());
    formatted += "_";
    formatted += get2DigitByFirstZeroPadding(date.getUTCMilliseconds());
    return formatted;
  }

  function get2DigitByFirstZeroPadding(digit)
  {
    var digit_str = "" + digit;
    if(digit < 10)
    {
      digit_str = "0" + digit_str;
    }
    return digit_str;
  }

  function getDateFromSimpleFormattedUtcDateStr(utc_str)
  {
    if(utc_str.length < 8)
    {
      return null;
    }

    var std_utc_str =
      utc_str.substr(0, 4) + "-"
      + utc_str.substr(4, 2) + "-"
      + utc_str.substr(6, 2) + "T"
      + utc_str.substr(9, 2) + ":"
      + utc_str.substr(11, 2) + ":"
      + utc_str.substr(13, 2) + "Z";
//console.log("std_utc_str:|" + std_utc_str + "|");

    var date = new Date(std_utc_str);
//console.log("date:|" + date.toUTCString() + "|");

    return date;
  }



function scrollToTop(){
  window.scroll(0,0);
}

function _console_log(msg)
{
  console.log(msg);
}

function _console_log_debug(msg)
{
  console.log(msg);
}

function show_ajax_response_error(resp_no, req_obj, textStatus, errorThrown)
{
  /*alert("[" + resp_no + "] " +
        "Error code : " + req_obj.status + "\n" +
        "message : " + req_obj.responseText + "\n" +
        "text status : " + textStatus + "\n" +
        "error : " + errorThrown);

   */
  _console_log("[" + resp_no + "] " +
          "Error code : " + req_obj.status + "\n" +
          "message : " + req_obj.responseText + "\n" +
          "text status : " + textStatus + "\n" +
          "error : " + errorThrown);
}

function copy_code_to_clipboard(code)
{
  /*
  var isIE = (navigator.userAgent.toLowerCase().indexOf("msie") != -1 ||
              navigator.userAgent.toLowerCase().indexOf("trident") != -1);

  if(isIE)
  {
    window.clipboardData.setData('Text', code);
  }
  else
  {
    prompt("Ctrl+C를 눌러 복사하세요.", code);
  }*/
  var t = document.createElement("textarea");
  document.body.appendChild(t);
  t.value = code;
  t.select();
  document.execCommand('copy');
  document.body.removeChild(t);
}

// Check if number
function is_number(n)
{
  var regex = /^[ \t]*([1-9][0-9]{0,2}(,[0-9]{3})*|[1-9][0-9]*)[ \t]*$/g;

  return regex.test(n);
}

function numberWithCommas(x)
{
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function money_format(x)
{
  return x.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
}

function getParameterByName(name, url)
{
  if(!url)
    url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
  var results = regex.exec(url);
  if(!results)
    return null;
  if(!results[2])
    return '';

  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function getCurrentLocalDateTime()
{
  const now = new Date();
  //console.log(now.toISOString().replaceAll(/T/g, " ").replaceAll(/\.[0-9]{3}Z$/g, ""));
  //return now.toISOString().replaceAll(/T/g, " ").replaceAll(/\.[0-9]{3}Z$/g, "");
  var la = moment().tz('America/Los_Angeles');
  //console.log(la.format('YYYY-MM-DD HH:mm:ss'));
  return la.format('YYYY-MM-DD HH:mm:ss');
}

function getCurrentISODateTime()
{
  var d = new Date();
  /*console.log(
      "toDateString():" + d.toDateString() +
      "|\ntoTimeString():" + d.toTimeString() +
      "|\ntoGMTString():" + d.toGMTString() +
      "|\ntoISOString():" + d.toISOString() +
      "|\ntoJSON():" + d.toJSON() +
      "|\ntoLocaleDateString():" + d.toLocaleDateString() +
      "|\ntoLocaleString():" + d.toLocaleString() +
      "|\ntoString():" + d.toString() +
      "|\ntoUTCString():" + d.toUTCString());*/
  /*
toDateString():Thu Feb 22 2018|
toTimeString():16:08:50 GMT+0900 (KST)|
toGMTString():Thu, 22 Feb 2018 07:08:50 GMT|
toISOString():2018-02-22T07:08:50.789Z|
toJSON():2018-02-22T07:08:50.789Z|
toLocaleDateString():2018. 2. 22.|
toLocaleString():2018. 2. 22. 오후 4:08:50|
toString():Thu Feb 22 2018 16:08:50 GMT+0900 (KST)|
toUTCString():Thu, 22 Feb 2018 07:08:50 GMT
    */
  return d.toISOString().substring(0,19);
}

function numTo2Digit(num)
{
  var two_digit_str = num + "";
  if(num < 10)
  {
    two_digit_str = "0" + two_digit_str;
  }
  return two_digit_str;
}

function getCurrentDateTime()
{
  return getCurrentDateTimeMsec().substring(0,19);
}

function getCurrentDateTimeMsec()
{
  var d = new Date();

  return d.getFullYear()
    + "-" + numTo2Digit(d.getMonth())
    + "-" + numTo2Digit(d.getDate())
    + " " + numTo2Digit(d.getHours())
    + ":" + numTo2Digit(d.getMinutes())
    + ":" + numTo2Digit(d.getSeconds())
    + "." + d.getMilliseconds();
}

function getDateTime(date_obj)
{
  var d = date_obj;

  return d.getFullYear()
          + "-" + numTo2Digit(d.getMonth())
          + "-" + numTo2Digit(d.getDate())
          + " " + numTo2Digit(d.getHours())
          + ":" + numTo2Digit(d.getMinutes())
          + ":" + numTo2Digit(d.getSeconds());
}

function get_number_from_money(money_str)
{
  return (money_str.replace("$","").replace(/,/g,"") * 1);
}

function is_empty(e) {
  switch (e) {
    case "":
    case 0:
    case "0":
    case "0.00":
    case null:
    case false:
    case undefined:
    case typeof this == "undefined":
      return true;
    default:
      return false;
  }
}

window.is_mobile = function() {
  
  return $(window).width() <= 480;
  /*
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
  */
};

window.is_mobile_tablet = function() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

function sleep(delay_msec)
{
   var start = new Date().getTime();
   while(new Date().getTime() < start + delay_msec);
}
